import React from 'react';
import { content, contactInfo } from '../data/mock';
import './Header.css';

const Header = ({ language, onLanguageChange }) => {
  const t = content[language];

  return (
    <header className="topbar">
      <div className="container topbar-inner">
        <a href="#top" className="brand">
          <img src="/assets/logo-main.png" alt="Brilliant Touch logo" />
          <div>
            <strong>{t.brandName}</strong>
            <small>{t.brandTagline}</small>
          </div>
        </a>

        <nav className="nav">
          <a href="#services">{t.nav.services}</a>
          <a href="#results">{t.nav.results}</a>
          <a href="#areas">{t.nav.areas}</a>
          <a href="#contact">{t.nav.contact}</a>
          <div className="lang-toggle" aria-label="Language switcher">
            <button
              className={language === 'en' ? 'active' : ''}
              onClick={() => onLanguageChange('en')}
              type="button"
            >
              EN
            </button>
            <button
              className={language === 'es' ? 'active' : ''}
              onClick={() => onLanguageChange('es')}
              type="button"
            >
              ES
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
